<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="queryVolumesByGroupIdList"
      style="width: 100.1%;"
    >
      <template slot-scope="{ row, index }" slot="actions">
        <Button type="info" size="small" @click="databaseDetail(row)"
          >详情</Button
        >
        <span @click="doDelete(index)">
          <!-- <Button type="info" size="small" @click="configurationWeight(row)">配置权重</Button> -->
          <Button type="info" size="small" @click="handleShowMonitorIndex(row)"
            >配置监控指标</Button
          >
          <Button type="error" size="small" @click="volumeDelmodal = true">{{
            $t("alarms.common.delete")
          }}</Button>
        </span>
      </template>
    </Table>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>

    <Modal v-model="volumeDelmodal" width="360" :mask-closable="false">
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t("alarms.common.deleteConfirmation") }}</span>
      </p>
      <div style="text-align:center">
        <p>
          {{ $t("alarms.common.sureDelete") }} {{ volumeName }}
          {{ $t("alarms.common.what") }}?
        </p>
      </div>
      <div slot="footer">
        <Button
          type="error"
          size="large"
          long
          @click="deleteVolume()"
          :disabled="isDisable"
          >{{ $t("alarms.common.delete") }}</Button
        >
      </div>
    </Modal>

    <Modal
      v-model="ShowMonitorIndexModal"
      title="配置监控指标"
      :loading="loading"
      :mask-closable="false"
      width="750"
    >
      <Form ref="MonitorIndexForm" :model="MonitorIndexForm" :label-width="110">
        <FormItem label="监控指标" prop="MonitorIndex">
          <Select
            filterable
            v-model="MonitorIndexForm.metricIndex"
            style="width:300px;"
            label-in-value
            @on-change="handleSelectMonitorIndex"
          >
            <Option
              v-for="item in MonitorIndexList"
              :value="item.id"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
          <Button
            type="primary"
            style="margin-left:20px"
            @click="handleAddMonitorIndex"
            >添加</Button
          >
        </FormItem>
        <div
          v-for="(item, index) in MonitorIndexForm.MonitorIndexArr"
          :key="item.id"
        >
          <Row :gutter="4">
            <Col span="10">
              <FormItem label="监控指标">
                <Input
                  v-model="item.metricName"
                  style="width:180px"
                  disabled
                ></Input> </FormItem
            ></Col>
            <Col span="10">
              <FormItem label="告警阈值">
                <Input
                  v-model="item.metricThresholdValue"
                  style="width:180px; "
                ></Input> </FormItem
            ></Col>
            <Col span="4">
              <FormItem label="" :label-width="30">
                <Button type="error" @click="handleDelMonitorIndex(index)"
                  >删除</Button
                >
              </FormItem>
            </Col>
          </Row>
        </div>
      </Form>
      <div slot="footer">
        <Button @click="caseResetMonitorIndex('ruleValidateMonitorIndexForm')"
          >取消</Button
        >
        <Button
          type="primary"
          @click="caseSubmitMonitorIndex('ruleValidateMonitorIndexForm')"
          >确定</Button
        >
      </div>
    </Modal>
  </div>
</template>
<script>
import utils from "@/utils/utils";
var tableVolumes = {};
export default {
  name: "TableVolumes",
  props: ["getAccountType"],
  data() {
    return {
      ShowMonitorIndexModal: false,
      MonitorIndexForm: {
        metricIndex: "",
        MonitorIndexArr: []
      },
      MonitorIndexList: [
        { id: "2", name: "磁盘使用率" },
        { id: "5", name: "读IOPS" },
        { id: "6", name: "写IOPS" },
        { id: "28", name: "读吞吐量" },
        { id: "29", name: "写吞吐量" }
      ],
      getItem: {},
      accountType: "",
      accountName: "",
      instanceId: "",
      volumeId: "",
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      volumeName: "",
      modalLoading: true,
      loading: false,
      volumeDelmodal: false,
      isDisable: false,
      state: [
        "creating",
        "available",
        "in-use",
        "deleting",
        "deleted",
        "error"
      ],
      columns: [
        {
          title: this.$t(
            "permission_configuration_management.group.accountName"
          ),
          key: "accountName"
        },
        {
          title: this.$t(
            "permission_configuration_management.group.instanceID"
          ),
          key: "instanceId"
        },
        {
          title: this.$t("permission_configuration_management.group.volumeID"),
          key: "volumeAwsId"
        },
        {
          title: this.$t("permission_configuration_management.group.name"),
          key: "name"
        },
        {
          title: this.$t(
            "permission_configuration_management.group.deviceName"
          ),
          key: "deviceName"
        },
        {
          title: this.$t(
            "permission_configuration_management.group.diskStorage"
          ),
          key: "capacity"
        },
        {
          title: this.$t("permission_configuration_management.group.type"),
          key: "type"
        },
        {
          title: this.$t(
            "permission_configuration_management.group.readingSpeed"
          ),
          key: "iops"
        },
        {
          title: this.$t(
            "permission_configuration_management.group.encryption"
          ),
          key: "encrypted"
        },
        {
          title: this.$t("permission_configuration_management.group.region"),
          key: "region"
        },
        {
          title: this.$t("permission_configuration_management.group.status"),
          key: "stateName"
        },
        {
          title: this.$t("common.operation"),
          width: 240,
          slot: "actions"
        }
      ],
      queryVolumesByGroupIdList: []
    };
  },
  beforeCreate: function() {
    tableVolumes = this;
  },
  methods: {
    caseSubmitMonitorIndex() {
      this.$api.brokerSummary
        .updateDiskWeight({
          applicationId: this.$route.query.id,
          diskId: this.id,
          alertRuleName: this.$route.query.alertRuleName,
          aiMetrics: this.MonitorIndexForm.MonitorIndexArr
        })
        .then(res => {
          this.$Message.success("操作成功");
          this.ShowMonitorIndexModal = false;
        });
    },
    databaseDetail: function(row) {
      this.$router.push({
        path: "/aiMonitor/volumesDetail/",
        query: { diskId: row.id }
      });
    },
    handleShowMonitorIndex(row) {
      this.ShowMonitorIndexModal = true;
      this.id = row.id;
      var lineIndex = this.lineIndex;
      this.$api.brokerSummary
        .selectWeightByApplicationIdAndDiskId({
          applicationId: this.$route.query.id,
          alertRuleName: this.$route.query.alertRuleName,
          diskId: row.id
        })
        .then(res => {
          this.MonitorIndexForm.MonitorIndexArr =
            res.data.aiApplicationMetricThresholdDTOS;
          let arr = [];
          this.MonitorIndexForm.MonitorIndexArr.forEach(item => {
            let data = {
              metricThresholdValue: item.thresholdValue,
              metricName: item.metricsName,
              metricIndex: item.metricsId
            };
            arr.push(data);
          });
          this.MonitorIndexForm.MonitorIndexArr = arr;
        })
        .catch(err => {});
    },
    caseResetMonitorIndex(name) {
      this.ShowMonitorIndexModal = false;
      this.MonitorIndexForm.MonitorIndexArr = [];
    },
    handleAddMonitorIndex(name) {
      this.MonitorIndexForm.MonitorIndexArr.push({
        metricIndex: this.getItem.value,
        metricName: this.getItem.label,
        metricThresholdValue: ""
      });
    },
    handleDelMonitorIndex(index) {
      this.MonitorIndexForm.MonitorIndexArr.splice(index, 1);
    },
    handleSelectMonitorIndex(item) {
      console.log(item);
      this.getItem = item;
    },

    // 点击备份目标的时候显示卷列表
    queryVolumesByGroupId: function() {
      tableVolumes.$api.brokerSummary
        .queryDisksByApplicationId({
          applicationId: this.$route.query.id,
          alertRuleName: this.$route.query.alertRuleName,
          pageNum: this.current,
          pageSize: this.pageSize
        })
        .then(res => {
          this.modalLoading = false;
          this.queryVolumesByGroupIdList = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        })
        .catch(res => {
          // 如果列表里没数据 返回
          this.queryVolumesByGroupIdList = undefined;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableVolumes.queryVolumesByGroupId();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableVolumes.queryVolumesByGroupId();
    },
    // 显示所有数据
    showAllVolume: function() {
      tableVolumes.queryVolumesByGroupId();
    },
    doDelete: function(index) {
      this.lineIndex = index;
      this.volumeName = this.queryVolumesByGroupIdList[index].name;
    },
    // 删除Volume
    deleteVolume: function() {
      this.isDisable = true; // 开始可以点击
      var lineIndex = this.lineIndex;
      // 删除卷
      tableVolumes.$api.brokerSummary
        .deleteByApplicationIdAndDiskId({
          alertRuleName: this.$route.query.alertRuleName,
          applicationId: this.$route.query.id,
          diskId: this.queryVolumesByGroupIdList[lineIndex].id
        })
        .then(res => {
          setTimeout(() => {
            // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
            //21条  3页  2*10+1时删除
            if (
              lineIndex == 0 &&
              (this.current - 1) * this.pageSize + 1 == this.dataTotal
            ) {
              this.current = this.current - 1;
            }
            this.dataTotal = this.dataTotal - 1;
            tableVolumes.queryVolumesByGroupId();
            this.isDisable = false;
            this.volumeDelmodal = false;
            this.$Message.success("删除成功");
          }, 1000);
        });
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/ai_monitor/application_configuration/TableVolumes.vue